const siteUrl = 'https://pixelmoxie.net';

module.exports = {
  siteTitle: 'Pixelmoxie',
  siteDescription:
    'The most beautiful, pixel-perfect, and customizable Tumblr themes—lovingly crafted to help you launch your portfolio, photography site or blog.',
  siteUrl,
  siteLogo: `${siteUrl}/logo.png`,
  siteImage: `${siteUrl}/logo.png`,
  pathPrefix: '/blog',
  siteRss: '',
  twitter: '@pixelmoxie',
  fbAppID: '',
  googleAnalyticsID: 'UA-36755600-11',
  disqusShortname: '',
  mailChimpURL:
    '//pixelmoxie.us17.list-manage.com/subscribe/post?u=2e86d3d5eda62994818155c12&id=63ece5b90a',
  postPerPage: 4, // Number of posts/articles to display for paginated pages.
  copyright: 'Copyright &copy;2018 Pixelmoxie.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#c62828', // Used for setting manifest and progress theme colors.
  backgroundColor: '#e0e0e0', // Used for setting manifest background color.
  navBreakpoint: 768,
  navItems: [
    {
      label: 'Themes',
      path: '/tumblr-themes',
      order: 1,
    },
    {
      label: 'Blog',
      path: '/blog',
      order: 2,
    },
    {
      label: 'Support',
      path: '/support',
      order: 3,
    },
  ],
  footerNavItems: [
    {
      label: 'Themes',
      path: '/tumblr-themes',
      order: 1,
    },
    {
      label: 'Blog',
      path: '/blog',
      order: 2,
    },
    {
      label: 'Support Policy',
      path: '/article/support-policy',
      order: 3,
    },
  ],
  socialLinks: [
    {
      label: 'Twitter',
      path: 'https://twitter.com/pixelmoxie',
      order: 1,
    },
    {
      label: 'Facebook',
      path: 'https://www.facebook.com/PixelMoxie-1864565843839567',
      order: 2,
    },
    {
      label: 'Instagram',
      path: 'https://www.instagram.com/pixelmoxie',
      order: 3,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/utils/config.js